<div class="header">
  <app-nav-button *ngIf="themeService.isClosable()" icon="xmark-circle" (clickEvent)="onCloseClicked()" />
  <div class="header-image-container" *ngIf="themeService.hasHeaderWordmark()">
    <app-game-icon *ngIf="themeService.drawerConfig().hasGameIcon" size="--spacing-x-large" [game]="gameId" />
    <div class="header-image-content">
      <div class="header-logo">
        <img [src]="themeService.appicon()" alt="t('clinch-logo-alt')" id="logo" />
      </div>
      <div class="typography-title-x-small-bold-primary">
        {{ gameName }}
      </div>
    </div>
  </div>
  <div class="header-image-container"  *ngIf="!themeService.hasHeaderWordmark()">
    <app-game-title [title]="gameName"></app-game-title>
  </div>
  <div
    *ngIf="themeService.showBalance()"
    class="chip">
    <span class="typography-text-medium-semibold-primary"> {{ balance }} </span>
    <ion-spinner *ngIf="!balance" name="crescent"/>
    <app-currency-icon 
      *ngIf="currencyIcon"
      [icon]="currencyIcon" 
      sizeCss="--icon-medium"
      class="currency-icon" />
  </div>
  <app-nav-button *ngIf="OperatorService.IsDemo" icon="brush" (clickEvent)="onThemeClicked()" />
</div>
<app-tab-bar *ngIf="tabs" [tabs]="tabs" buttonType="tab" (tabSelected)="onTabSelected($event)" />